const FJMathUtil = {
    /**
     * @desc 判断点是否在某个范围内
     * @param point {object} {x, y}
     * @param rect {object} {x, y, width, height}
     * @return {boolean}
     */
    isPointInRect: function (point, rect, isEqual = true) {
        if (!point || !rect) return false;
        if (isEqual) {
            return (
                point.x >= rect.x &&
                point.x <= rect.x + rect.width &&
                point.y >= rect.y &&
                point.y <= rect.y + rect.height
            );
        } else {
            return (
                point.x > rect.x && point.x < rect.x + rect.width && point.y > rect.y && point.y < rect.y + rect.height
            );
        }
    },
    /**
     * @desc 解析时间输入框input值
     * @param {*} inputValue
     * @returns seconds
     */
    parseTimeInput(inputValue) {
        let value = inputValue;
        if (/^[0-9]?[0-9]{1,3}:[0-9]?[0-9](:[0-5]?[0-9])?(\.[0-9])?$/.test(value)) {
            // 用户输入标准时间格式
            let timeList = value.split(':');
            let hour = '0';
            let minutes = '0';
            let seconds = '0';
            if (timeList.length === 3) {
                hour = timeList[0];
                minutes = timeList[1];
                seconds = timeList[2];
            } else {
                minutes = timeList[0];
                seconds = timeList[1];
            }

            if (seconds.indexOf('.') !== -1) {
                seconds = Math.floor(seconds * 10) / 10;
            }
            value = parseInt(hour) * 60 * 60 + parseInt(minutes) * 60 + parseFloat(seconds);
        } else if (/^(-?)[0-9]+(\.[0-9]+)?$/.test(value)) {
            // 用户输入秒数
            if (value.indexOf('.') !== -1) {
                value = Math.floor(value * 10) / 10;
            }
            value = parseFloat(value);
        } else if (/[0-9]+[sS]$/.test(value)) {
            value = value.replace(/s/i, '');
            if (value.indexOf('.') !== -1) {
                value = Math.floor(value * 10) / 10;
            }
            value = parseFloat(value);
        } else {
            return;
        }
        return value;
    },

    /**
     * @desc 转换点在旋转后的坐标
     * @param point - 坐标点
     * @param centerPoint - 中心点
     * @param angle - 旋转角度
     * @return {{x: *, y: *}}
     */
    convertPointByAngle: function (point, centerPoint, angle) {
        let l = (angle * Math.PI) / 180,
            cosv = Math.cos(l),
            sinv = -Math.sin(l);
        let x = (point.x - centerPoint.x) * cosv - (point.y - centerPoint.y) * sinv + centerPoint.x,
            y = (point.x - centerPoint.x) * sinv + (point.y - centerPoint.y) * cosv + centerPoint.y;
        return { x: x, y: y };
    },

    /**
     * @desc 求两个点之间的距离
     * @param point1 - 第一个点
     * @param point2 - 第二个点
     * @return {number} 两点之间的距离
     */
    getDistanceBetweenPoints: function (point1, point2) {
        const dx = point2.x - point1.x;
        const dy = point2.y - point1.y;
        return Math.sqrt(dx * dx + dy * dy);
    },

    /**
     * @desc 计算2点间的角度
     * @param currentPoint
     * @param centerPoint
     * @return {number} 逆时针角度
     * @private
     */
    angleAtPoint: function (currentPoint, centerPoint) {
        const dx = currentPoint.x - centerPoint.x;
        const dy = currentPoint.y - centerPoint.y;
        const angle = Math.atan2(dy, dx) * (180 / Math.PI);
        return angle;
    },
    /**
     * @desc 取得小数位精度的值
     * @param value
     * @param digits - 小数后第几位
     * @return {number}
     */
    floor: function (value, digits = 1) {
        let d = Math.pow(10, digits);
        if (value >= 0) return Math.floor(value * d) / d;
        else return -Math.floor(-value * d) / d;
    },
    /**
     * @description 从数组中随机取一个元素
     * @param {Array} arr
     * @param {Array} exclude
     * @returns
     */
    getRandomElementFromArray: function (arr, exclude) {
        let newArr = [...arr];
        if (!Array.isArray(arr) || arr.length === 0) {
            return null; // 如果不是数组或数组为空，返回 null
        }
        if (exclude) {
            let excludeArr = exclude;
            if (!Array.isArray(exclude)) {
                excludeArr = [exclude];
            }
            if (excludeArr.length > 0) {
                newArr = newArr.filter(item => !excludeArr.includes(item));
            }
        }
        const randomIndex = Math.floor(Math.random() * newArr.length);
        return newArr[randomIndex];
    },
};
export default FJMathUtil;
